module.exports = __webpack_public_path__ + "static/redux-f18023dce4a1ce45b2f977f9b7598404.png";